import styled from 'styled-components';
import { colors, typography, spacing, borderRadius, shadows, breakpoints } from '../../styles/theme';

export const FAQList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
`;

export const FAQItem = styled.div`
  background: ${colors.neutral.white};
  border-radius: ${borderRadius.xl};
  border: 1px solid ${colors.neutral.gray200};
  overflow: hidden;
  box-shadow: ${shadows.sm};
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  cursor: pointer;

  &:hover {
    box-shadow: ${shadows.md};
    border-color: ${colors.primary.orange};
  }
`;

export const FAQHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing.lg};
  gap: ${spacing.md};

  @media (max-width: ${breakpoints.md}) {
    padding: ${spacing.md};
  }
`;

export const FAQQuestion = styled.h4`
  font-size: ${typography.fontSize.lg};
  font-weight: ${typography.fontWeight.semibold};
  color: ${colors.primary.teal};
  margin: 0;

  @media (max-width: ${breakpoints.md}) {
    font-size: ${typography.fontSize.base};
  }
`;

export const FAQIcon = styled.div`
  color: ${colors.primary.orange};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  transform: ${props => (props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  flex-shrink: 0;
`;

export const FAQAnswer = styled.div`
  max-height: ${props => (props.$isOpen ? '300px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);
`;

export const FAQAnswerContent = styled.div`
  padding: 0 ${spacing.lg} ${spacing.lg};
  color: ${colors.neutral.gray600};
  font-size: ${typography.fontSize.base};
  line-height: ${typography.lineHeight.relaxed};
  border-top: 1px solid ${colors.neutral.gray100};
  padding-top: ${spacing.md};

  @media (max-width: ${breakpoints.md}) {
    padding: 0 ${spacing.md} ${spacing.md};
    padding-top: ${spacing.sm};
  }
`;
